import React, { useEffect, useState } from "react";
import {
  Form, Input, DatePicker, TimePicker, Select, Mentions, Button, message,
  Checkbox, Radio, Modal, Table
} from 'antd';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
dayjs.extend(advancedFormat);
import getOffsetTime from '../../../../utils/getOffsetTime.js';
import timeZones from '../../utils/live-schedules/drop-down-tables/timeZones.js';
import AuthLogic from '../../../../AuthLogic/index.js';
import './forms.scss';

const { TextArea } = Input;
const { Option } = Select;

const datePickerFormat = 'h:mm a, MMM Do'
const durationFormat = 'HH:mm';
const FormItem = Form.Item;

const EditTourMealsForm = React.memo(({ loading, resource, itemDetails, user, confirmDialogue,
  mealsTableDataSource, tourMeals, jobElementsByTour, meal, ...props
}) => {
  const { itemType } = itemDetails;
  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;
  const [selectedRowKeysArray, setSelectedRowKeysArray] = useState([0]); // first meal in table is first selected
  const [dirtyTableRows, setDirtyTableRows] = useState(false);

  const columns = [
    {
      title: 'Start Time',
      dataIndex: 'startTime',
      key: 'startTime',
    },
    {
      title: 'End Time',
      dataIndex: 'endTime',
      key: 'endTime',
    },
    {
      title: 'Assignment',
      dataIndex: 'jobelementId',
      key: 'jobElementId',
    }
  ];

  const handleSelectedRowChange = async (selectedRowKeys) => {
    setSelectedRowKeysArray(selectedRowKeys);
    let selectedMeal = tourMeals.data[selectedRowKeys[0]];
    itemDetails.selectedMealDetails = selectedMeal;
    meal = selectedMeal;
    await props.updateState({
      meal,
      itemDetails
    });
    console.log(selectedRowKeys); // debug
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeysArray, // Table component's selectedRowKeys is always an array
    onChange: handleSelectedRowChange,
    type: 'radio',
    onSelect: async (record, selected) => {
      // console.log(selected);
      // console.log(record);
    }
  };

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      console.log('Success! Received values of form: ', getFieldsValue())
      if (meal) {
        props.updateMeal();
      } else if (!meal) {
        props.createMeal();
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  };

  useEffect(() => {
    itemDetails.itemType = 'meal';
    props.updateState({ itemDetails });
  }, []);

  useEffect(() => {
    if (!dirtyTableRows) {
      // set meal initially selected when tab opens
      let selectedMeal = tourMeals.data[0];
      itemDetails.selectedMealDetails = selectedMeal;
      props.updateState({ itemDetails });
    }
    setDirtyTableRows(true);
  }), [];

  /**
   * populate fields on initial component mount
   * (getFieldDecorator overrides `value` on forms)
   */
  useEffect(() => {
    const form = props.form;
    form.setFieldsValue({
      mealStartTime: itemDetails.mealStartTime,
      mealDuration: itemDetails.mealDuration,
    });
  }, [itemDetails.mealStartTime, itemDetails.mealDuration, confirmDialogue, itemDetails.selectedMealDetails, selectedRowKeysArray]);

  // update fields from new meal selection
  useEffect(() => {
    if (itemDetails && meal && itemDetails.selectedMealDetails) {
      itemDetails.mealId = itemDetails.selectedMealDetails.id;
      itemDetails.jobElementId = itemDetails.selectedMealDetails.jobElementId;
      itemDetails.OTE = itemDetails.selectedMealDetails.OTE;
      itemDetails.autoAdd = itemDetails.selectedMealDetails.autoAdd;
      itemDetails.billable = itemDetails.selectedMealDetails.billable;

      // timezone offset adjustment
      let startTime = dayjs(itemDetails.selectedMealDetails.dateTimeStartActual);
      let endTime = dayjs(itemDetails.selectedMealDetails.dateTimeEndActual);
      let timeZoneOffset = getOffsetTime(startTime);
      let mealStartTime = startTime.add(timeZoneOffset, 'minute');
      let mealEndTime = endTime.add(timeZoneOffset, 'minute');

      // update starte/end time
      itemDetails.mealStartTime = mealStartTime;
      itemDetails.mealEndTime = mealEndTime;
      props.generateItemDuration('meal', mealStartTime, mealEndTime);
    } else if (itemDetails && !meal) {
      // clear fields for create new meal form
      itemDetails.mealId = null;
      itemDetails.jobElementId = null;
      itemDetails.OTE = null;
      itemDetails.autoAdd = null;
      itemDetails.billable = null;
      // update starte/end time
      itemDetails.mealStartTime = null;
      itemDetails.mealEndTime = null;
      props.generateItemDuration('meal', itemDetails.mealStartTime, itemDetails.mealEndTime);
    }

    props.updateState({ itemDetails });

  }, [itemDetails, itemDetails.selectedMealDetails, meal, selectedRowKeysArray])


  const switchToNewMealForm = async () => {
    meal = null;
    props.updateState({ meal });
    setSelectedRowKeysArray(null); // un-select anything in table
  }

  if (itemDetails && !loading
  ) {
    // console.log(`selectedRowKeysArray: ${selectedRowKeysArray}`) // debug
    // console.log(`dirtyTableRows: ${dirtyTableRows}`);

    return (

      <Form onSubmit={handleSubmit}>

        <FormItem>
          <Table
            dataSource={mealsTableDataSource}
            columns={columns}
            rowSelection={rowSelection}
          // rowClassName={(record) =>  record.color ? record.color.replace('#', '') : null}
          // onRow={(record) => record.key === selectedRowKeysArray[0] ? record.color = 'greenRow' : null}
          // ßrowClassName={(record) => ''}
          />
        </FormItem>

        <FormItem
          label="Start Time"
          style={{ display: "flex", marginBottom: 5 }}
        >
          {getFieldDecorator('mealStartTime', {
            rules: [{
              required: true, message: 'Please input start time!',
              type: 'object'
            }],
          })(
            <DatePicker
              name="mealStartTime"
              showTime={{ format: datePickerFormat, use12Hours: true, minuteStep: 15 }}
              onChange={props.handleItemStartTimeChange}
              placeholder={'Select date and time'}
              format={datePickerFormat}
              allowClear={false}
              size={'large'}
              styles={{
                popup: {
                  root: {
                    zIndex: 2000
                  }
                }
              }}
            />
          )}
        </FormItem>

        <FormItem
          label="Duration"
          style={{ display: "flex", marginBottom: 5 }}
        >
          {itemDetails.mealDuration && itemDetails.mealDurationDays && itemDetails.mealDurationDays.days &&
            (
              <span>
                <Mentions
                  value={itemDetails.mealDurationDays.days}
                  readOnly
                  style={{ marginLeft: 10, marginRight: 5, width: 50 }}
                />
                <span>day(s) &</span>
              </span>
            )
          }
          {getFieldDecorator('mealDuration', {
            rules: [{
              required: true, message: 'Duration is required!',
              type: 'object'
            }],
          })(
            <TimePicker
              name="mealDuration"
              onChange={props.handleItemDurationChange}
              allowClear={false}
              format={durationFormat}
              minuteStep={15}
              style={{ marginLeft: 5, marginRight: 5 }}
              showNow={false}
            />
          )}
          hours
        </FormItem>


        <FormItem
          label={'Assignment'}
          style={{ display: "flex", marginBottom: 5 }}
        >
          <Select
            name="jobElementId"
            value={`jobElementId-${itemDetails.jobElementId ? itemDetails.jobElementId.toString() : 0}`}
            onChange={props.handleOmnibusFieldChange}
            disabled={!itemDetails.billable}
            style={{ width: 300 }}
          >
            <Option key={null} value={`jobElementId-${0}`}>&nbsp;</Option>

            {jobElementsByTour &&
              jobElementsByTour.data.map((elem) => {
                return <Option key={elem.id} value={`jobElementId-${elem.id}`}>
                  {`${elem.jobNumber}/${elem.startActual.split('T')[1].slice(0, 5)}-${elem.endActual.split('T')[1].slice(0, 5)}/${elem.service}`}
                </Option>
              })}
          </Select>
        </FormItem>

        <FormItem
          label="Billable"
          style={{ display: "flex", marginBottom: 5 }}
        >
          {getFieldDecorator('billable', {
          })(
            <Checkbox
              name="billable"
              checked={itemDetails.billable}
              onChange={props.handleOmnibusFieldChange}
              size={'large'}
            />
          )}
        </FormItem>

        <FormItem
          style={{ marginTop: 20 }}
        >
          {meal &&
            (
              <React.Fragment>
                <Button type="primary" ghost size={'large'} htmlType="submit">
                  Update
                </Button>
                <Button type="danger" ghost size={'large'} onClick={() => props.handleItemDelete('meal')} >
                  Delete
                </Button>
                <Button type="default" size={'large'} onClick={() => switchToNewMealForm()} >
                  New
                </Button>
              </React.Fragment>
            )
          }
          {!meal &&
            <Button type="default" size={'large'} htmlType="submit">
              Save
            </Button>
          }
        </FormItem>

      </Form>
    );
  } else return 'loading...'
})

export default EditTourMealsForm;

